
import { createReducer, on } from '@ngrx/store';
import { loadAdvisorData, loadAdvisorDataSuccess, loadAdvisorDataFailure } from '../actions/advisors.actions';

export interface State {
  advisorData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  advisorData: [],
  loading: false,
  error: null,
};

export const advisorReducer = createReducer(
  initialState,
  on(loadAdvisorData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadAdvisorDataSuccess, (state, { advisorData }) => ({
    ...state,
    loading: false,
    advisorData,
  })),
  on(loadAdvisorDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
